import moment from 'moment'
import constants from './constants'

const initialState = { scheduledOrders: [], scheduledOrder: null }

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_SCHEDULED_ORDERS_ORDERS': {
      return state || initialState
    }
    case 'GET_SCHEDULED_ORDERS_SUCCESS': {
      var today = action.meta.previousAction.date
      var tomorrow = moment(today).add(1, 'day')
      var nextOrders = []
      var result = {}
      action.payload.data &&
        action.payload.data.participantSchedulesModel &&
        action.payload.data.participantSchedulesModel.map(
          (itemParticipantSchedule, indexItemParticipantSchedule) => {
            var firstScheduleMoment = moment(
              itemParticipantSchedule.firstSchedule
            )
              .utc()
              .format('DD/MM/YYYY')
            var lastScheduleMoment = moment(
              itemParticipantSchedule.lastSchedule
            )
              .utc()
              .format('DD/MM/YYYY')

            var nextScheduledOrder = null

            itemParticipantSchedule.serviceItem.map(
              (itemSchedule, indexSchedule) => {
                if (
                  itemSchedule.status.statusId ===
                  constants.STATUS_MOBILE_RECHARGE_STATUS_CANCELED
                ) {
                  return
                }

                var dayKey = moment(itemSchedule.schedulingDate)
                  .utc()
                  .date()
                var yearKey = moment(itemSchedule.schedulingDate)
                  .utc()
                  .year()
                var monthKey = moment(itemSchedule.schedulingDate)
                  .utc()
                  .month()
                var schedulingDate = moment(itemSchedule.schedulingDate)

                if (!result[yearKey]) result[yearKey] = {}
                if (!result[yearKey][monthKey]) result[yearKey][monthKey] = {}
                if (!result[yearKey][monthKey][dayKey]) {
                  result[yearKey][monthKey][dayKey] = []
                }

                var scheduledOrder = {
                  scheduleDate: itemParticipantSchedule.dateCreatedScheduling,
                  description: `${itemParticipantSchedule.ddd} ${itemParticipantSchedule.phone} agendado de ${firstScheduleMoment} até ${lastScheduleMoment}`,
                  pointValue: itemSchedule.pointValue,
                  vendorId: itemParticipantSchedule.vendorId,
                  serviceItemId: itemSchedule.id,
                  editable:
                    tomorrow.format('YYYYMMDD') <=
                    schedulingDate.format('YYYYMMDD'),
                  indexServiceItem: indexSchedule,
                  itemParticipantSchedule: itemParticipantSchedule
                }

                result[yearKey][monthKey][dayKey].push(scheduledOrder)

                if (
                  !nextScheduledOrder &&
                  tomorrow.format('YYYYMMDD') <=
                    schedulingDate.format('YYYYMMDD')
                ) {
                  nextScheduledOrder = scheduledOrder
                }
              }
            )
            if (nextScheduledOrder) nextOrders.push(nextScheduledOrder)
            nextScheduledOrder = null
          }
        )

      return {
        scheduledOrders: result,
        nextOrders: nextOrders,
        sourcescheduledOrders: action.payload.data.participantSchedulesModel
      }
    }
    case 'GET_NEXT_SCHEDULED_ORDERS_FAIL': {
      return state || initialState
    }
    case 'EDIT_SERVICE_ITEM': {
      if (!action.item) return state

      var scheduledOrder =
        action.item.itemParticipantSchedule.serviceItem[
          action.item.indexServiceItem
        ]

      scheduledOrder.operator = action.item.itemParticipantSchedule.operator
      scheduledOrder.phone = action.item.itemParticipantSchedule.phone
      scheduledOrder.areaCode = action.item.itemParticipantSchedule.ddd

      return {
        ...state,
        scheduledOrder: scheduledOrder,
        participantSchedulesModel: action.item.itemParticipantSchedule,
        indexServiceItem: action.item.indexServiceItem
      }
    }
    case 'NEW_SERVICE_ITEM': {
      delete state.indexServiceItem
      return {
        ...state,
        scheduledOrder: {},
        participantSchedulesModel: {}
      }
    }
    case 'CLEAR_SERVICE_ITEM':
      delete state.scheduledOrder
      delete state.participantSchedulesModel
      delete state.indexServiceItem
      delete state.isLoadingUpdate
      return state
    case 'SHOW_ERRORMESSAGE_RECHARGE':
      state.message = action.message
      return state
    case 'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER':
      return { ...state, isLoadingUpdate: true }
    case 'UPDATE_MOBILE_RECHARGE_SCHEDULE_ORDER_END':
      delete state.isLoadingUpdate
      return state
    case 'MOBILE_RECHARGE_FINALIZE_ORDER':
      return { ...state, isLoadingInsert: true }
    case 'MOBILE_RECHARGE_FINALIZE_ORDER_END':
      delete state.isLoadingInsert
      return state
    case 'CLEAR_ERROR_MESSAGE':
      delete state.errorMessage
      return state
    default:
      return state || initialState
  }
}



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/reducer.js